
import axiosLogin from "global/helpers/axiosLogin";
import { JSONCONFIG_SUCCESS, SET_CONFIG_TERMINAL } from "../../ActionTypes";

export const guardarJsonConfig = (json) => (dispatch) => {
  dispatch({
    type: JSONCONFIG_SUCCESS,
    payload: json,
  });
};

export const wsGetConfig = (id, nextStep) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/shared/terminal/${id}`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        let error;
        if (err.response !== undefined && err.response !== null) {
          error = {
            detail:
              err.response.data !== undefined && err.response.data !== null
                ? err.response.data
                : "Error al contactar el server.",
            origen: "portal",
          };
        } else {
          error = {
            detail: "Error al contactar el server.",
            origen: "portal",
          };
        }
        if (nextStep) nextStep(false, error);
      });
  });
};

export const setConfigTerminal = (configTerminal) => (dispatch) => {
  dispatch({ type: SET_CONFIG_TERMINAL, payload: configTerminal });
};
